import { isBrowser } from 'utils';
const DEFAULT_DELAY_INTERVAL = 150;

export function delay(time = DEFAULT_DELAY_INTERVAL): {
  setDelay: (cb: () => void) => void;
  cleanup: () => void;
} {
  let timer: number;
  const cleanup = () => {
    timer && clearTimeout(timer);
  };
  const setDelay = (cb: () => void) => {
    if (!isBrowser()) {
      return;
    }
    if (timer) {
      clearTimeout(timer);
    }
    timer = window.setTimeout(cb, time);
  };
  return {
    setDelay,
    cleanup
  };
}
